import { Message } from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
    if(messageInstance) {
      messageInstance.close()
    }
    // messageInstance = Message(options)
    messageInstance = Message({
        ...options,
        offset:220,
		customClass:'global_messageZindex'
    })
  }
;
['error','success','info','warning'].forEach(type => {
  resetMessage[type] = options => {
    if(typeof options === 'string') {
      options = {
        message:options,
        offset:220
      }
    }
    options.type = type;
    return resetMessage(options);
  }
});
export default resetMessage;